// extracted by mini-css-extract-plugin
export default {"dot":"dot--90BpR","dot--active":"dot--active--Fd4sl","dotActive":"dot--active--Fd4sl","dot--inactive":"dot--inactive--cTxS1","dotInactive":"dot--inactive--cTxS1"};